import { useInspectionStore } from '../store';
import type { InspectionTemplateSlice } from '../slices/inspectionTemplate';

type InspectionTemplateCommands = Pick<
  InspectionTemplateSlice,
  | 'openInspectionTemplate'
  | 'createInspectionTemplate'
  | 'updateInspectionTemplate'
  | 'removeInspectionTemplate'
  | 'publishInspectionTemplate'
  | 'createInspectionTemplateChecklistItems'
  | 'updateInspectionTemplateChecklistItem'
  | 'removeInspectionTemplateChecklistItem'
  | 'reorderInspectionTemplateChecklistItem'
  | 'createChecklistSection'
  | 'updateChecklistSection'
  | 'removeChecklistSection'
  | 'reorderChecklistSection'
  | 'createChecklistAnswer'
  | 'updateChecklistAnswer'
  | 'removeChecklistAnswer'
>;

export type UseInspectionTemplateResult = Pick<
  InspectionTemplateSlice,
  'inspectionTemplate' | 'inspectionTemplateDocuments' | 'templateId'
> &
  InspectionTemplateCommands & {
    loading: boolean;
    loadingDocuments: boolean;
  };

export function useInspectionTemplate(): UseInspectionTemplateResult {
  return {
    inspectionTemplate: useInspectionStore.use.inspectionTemplate(),
    inspectionTemplateDocuments: useInspectionStore.use.inspectionTemplateDocuments(),
    loading: useInspectionStore.use.loadingTemplate(),
    loadingDocuments: useInspectionStore.use.loadingTemplateDocuments(),
    templateId: useInspectionStore.use.templateId(),
    openInspectionTemplate: useInspectionStore.use.openInspectionTemplate(),
    createInspectionTemplate: useInspectionStore.use.createInspectionTemplate(),
    updateInspectionTemplate: useInspectionStore.use.updateInspectionTemplate(),
    removeInspectionTemplate: useInspectionStore.use.removeInspectionTemplate(),
    publishInspectionTemplate: useInspectionStore.use.publishInspectionTemplate(),
    createInspectionTemplateChecklistItems: useInspectionStore.use.createInspectionTemplateChecklistItems(),
    updateInspectionTemplateChecklistItem: useInspectionStore.use.updateInspectionTemplateChecklistItem(),
    removeInspectionTemplateChecklistItem: useInspectionStore.use.removeInspectionTemplateChecklistItem(),
    reorderInspectionTemplateChecklistItem: useInspectionStore.use.reorderInspectionTemplateChecklistItem(),
    createChecklistSection: useInspectionStore.use.createChecklistSection(),
    updateChecklistSection: useInspectionStore.use.updateChecklistSection(),
    removeChecklistSection: useInspectionStore.use.removeChecklistSection(),
    reorderChecklistSection: useInspectionStore.use.reorderChecklistSection(),
    createChecklistAnswer: useInspectionStore.use.createChecklistAnswer(),
    updateChecklistAnswer: useInspectionStore.use.updateChecklistAnswer(),
    removeChecklistAnswer: useInspectionStore.use.removeChecklistAnswer(),
  };
}
